import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ForcePasswordChangeWrapper
 * 
 * Blocks access to the app if the user must change their password.
 * Redirects to /change-password with forced=true state.
 * 
 * Allows access to:
 * - /change-password (so user can change password)
 * - /login (if not authenticated)
 * - /logout routes
 */
const ForcePasswordChangeWrapper = ({ children }) => {
  const { mustChangePassword, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // While loading, don't redirect
  if (loading) {
    return children;
  }

  // If not authenticated, don't apply this wrapper
  if (!isAuthenticated) {
    return children;
  }

  // List of paths that should be allowed even with forced password change
  const allowedPaths = ['/change-password', '/login', '/logout', '/set-password'];
  
  // Check if current path is allowed
  const isAllowedPath = allowedPaths.some(path => location.pathname.startsWith(path));

  // If user must change password and not on an allowed path, redirect
  if (mustChangePassword && !isAllowedPath) {
    return <Navigate to="/change-password" state={{ forced: true }} replace />;
  }

  return children;
};

export default ForcePasswordChangeWrapper;
